import remarkGfm from 'remark-gfm';

export const TEST_ID = 'legalPage';

export const REMARK_PLUGINS = [remarkGfm];
